import MotionDiv from 'global/motions/MotionDiv';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useEffect } from 'react';
import { Modal } from 'semantic-ui-react';

const ModalOverlay = ({ header, content, frameworkRef, handleCancel, closeOverlay, isOverlay, isSidebar }) => {

  console.log('isOverlay', isOverlay)

  useEffect(() => {
    if (!isOverlay) { return; }
    // Push a dummy history entry so back button can close modal
    window.history.pushState(null, '');

    const onPopState = () => {
      closeOverlay(); // close overlay when back button/swipe occurs
    };

    window.addEventListener('popstate', onPopState);

    return () => window.removeEventListener('popstate', onPopState);
  }, [isOverlay, closeOverlay]);

  const handle_closeOverlay = () => {
    if (isOverlay) {
      window.history.back();
    }
  }

  const modal_main = () => <Modal
    onClose={() => handleCancel()}
    onOpen={() => handleCancel()}
    open={true}
    className={isOverlay ? 'lpw-modal overlay' : 'lpw-modal grd'}
    mountNode={frameworkRef?.current || null} // crucial: modal stays in wrapper 
  >
    <div className='header'>{header}</div>
    <div className='content'>{content}</div>
  </Modal>

  const wrapper_main = () => <Wrapper
    header={header}
    content={content}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_main = () =>
    <MotionDiv transition={{ duration: .2 }}>
      <FullPageWrapper
        content={wrapper_main()}
        // handleCancel={handle_closeOverlay}
        isOverlay={isOverlay}
        isSidebar={isSidebar}
      /></MotionDiv>

  return (
    isOverlay ? fpw_main() : modal_main()
  );
};

export default ModalOverlay;
